import _ from "lodash";

class ModelMapperService {

    mapToCurrentUserModel = (user) => {
        if (user.length === 0) return [];

        return {
            fullName: user.fullName,
            initials: user.initials,
            customerName: user.customerName,
            allClaims: user.allClaims
        };
    };

    mapToPendoUserDataModel = (user) => {
        if (user.length === 0) return [];

        return {
            visitor: {
                id: user.id,
                email: user.email,
                role: "None"
            },

            account: {
                id: user.customerId,
                name: user.customerName
            }
        };
    };

    mapUserProduct = (allProducts, userProducts = {}) => {
        const myProducts = allProducts.filter(p => Object.keys(userProducts).find(up => up.toLowerCase() === p.name.toLowerCase()) !== undefined)
            .filter(p => p.isBackendProduct === false)
            .map(p => {
                return {
                    id: p.productId,
                    name: p.name,
                    displayName: p.displayName,
                    icon: p.icon
                };
            });

        return _.orderBy(myProducts, ["displayName"]);
    };
}

const mapper = new ModelMapperService();
export default mapper;

